import { Button, Form, Select, Input, Radio, notification } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import auditedServices from "../../servicios/vehiculos/serviciosAudit";
const { crearVehiculo } = auditedServices;

const AgregarVehiculo = () => {
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
    });
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const tokenValid = await auth.currentUser.getIdToken(true);

      const body = {
        marca: values.marca,
        modelo: values.modelo,
        color: values.color,
        placa: values.placa.toUpperCase(),
        tipo_gasolina: values.tipo_gasolina,
        engomado: values.engomado,
        sucursal: values.sucursal,
      };
      const response = await crearVehiculo(tokenValid, body);
      if (response.success) {
        openNotificationWithIcon(
          "success",
          "Vehiculo agregado",
          `El vehículo con placa ${values.placa} se guardó exitosamente.`
        );
        form.resetFields();
      } else {
        openNotificationWithIcon(
          "warning",
          "Vehiculo no guardado",
          response.msg || response.error?.msg || response.error
        );
      }
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Vehiculo no guardado",
  `No se guardó el vehículo. Intenta de nuevo.`
      );
      console.error("Error: ", error);
    }
    setLoading(false);
  };



  return (
    <>
      {contextHolder}
      <Title level={3} className="ccg-center">
        Agregar Vehículo
      </Title>
      <Form
        form={form}
        style={{ maxWidth: 600, margin: "auto", textAlign: "center" }}
        name="agregar-vehiculo"
        onFinish={onFinish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label="Marca"
          name="marca"
          rules={[{ required: true, message: "Por favor ingresa la marca" }]}
        >
          <Input placeholder="Ejemplo: Nissan, Toyota, Ford..." />
        </Form.Item>
        <Form.Item
          label="Modelo (Año)"
          name="modelo"
          rules={[
            { required: true, message: "Por favor ingresa el año del modelo" },
            { pattern: /^\d{4}$/, message: "El modelo debe ser un año de 4 dígitos" },
            { validator: (_, value) => {
                const year = parseInt(value, 10);
                if (!value || (year >= 1980 && year <= new Date().getFullYear() + 1)) return Promise.resolve();
                return Promise.reject("Año fuera de rango válido");
              }
            }
          ]}
        >
          <Input placeholder="Ejemplo: 2022" maxLength={4} />
        </Form.Item>
        <Form.Item
          label="Color"
          name="color"
          rules={[{ required: true, message: "Por favor ingresa el color" }]}
        >
          <Input placeholder="Ejemplo: Rojo, Azul, Blanco..." />
        </Form.Item>
        <Form.Item
          label="Placa"
          name="placa"
          rules={[
            { required: true, message: "Por favor ingresa la placa" },
            { pattern: /^[A-Z0-9]{3}-[A-Z0-9]{3,4}$/, message: "Formato inválido. Ejemplo: ABC-1234 o 12A-1B34" }
          ]}
        >
          <Input
            placeholder="Ejemplo: ABC-1234"
            maxLength={8}
            style={{ textTransform: 'uppercase' }}
            onChange={e => {
              const upper = e.target.value.toUpperCase();
              form.setFieldsValue({ placa: upper });
            }}
          />
        </Form.Item>
        <Form.Item
          label="Tipo de gasolina"
          name="tipo_gasolina"
          rules={[{ required: true, message: "Por favor selecciona el tipo de gasolina" }]}
        >
          <Select placeholder="Selecciona el tipo de gasolina">
            <Option value="Magna">Magna</Option>
            <Option value="Premium">Premium</Option>
            <Option value="Diesel">Diesel</Option>
            <Option value="Eléctrico">Eléctrico</Option>
            <Option value="Otro">Otro</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Engomado"
          name="engomado"
          rules={[{ required: true, message: "Por favor ingresa el engomado" }]}
        >
          <Input placeholder="Ejemplo: Verde, Amarillo, Rojo..." />
        </Form.Item>
        <Form.Item
          label="Sucursal"
          name="sucursal"
          rules={[{ required: true, message: "Por favor selecciona una sucursal" }]}
        >
          <Select placeholder="Selecciona una sucursal">
            <Option value="Centro">Centro</Option>
            <Option value="Playa del Carmen">Playa del Carmen</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Guardar
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AgregarVehiculo;
